import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { constObj } from '../../common/Constants/constants';
import { CommonDataService } from '../../common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { HttpcallService } from '../../common/services/httpcall.service';
import { LoginService } from '../../common/services/Login.service';
import { SessionService } from '../../common/services/Session.service';


@Component({
  selector: 'app-my-history',
  templateUrl: './my-history.component.html',
  styleUrls: ['./my-history.component.css']
})
export class MyHistoryComponent implements OnInit {
  public displayedColumns = []
  public dataSource = new MatTableDataSource<MyHistory>();
  res: MyHistory[];
  actualresult: any;
  pagelistarray: any[] = [];
  noRecords = constObj.Norecords;
  pagesize: any = 10;
  showhistorylist=[];
  showhistorydefault;
  emailId: string = "";
  outcome: boolean = false;
  constructor(private httpCallService: HttpcallService, public commonDataService: CommonDataService, private loginService: LoginService, private session: SessionService,
    private route: Router, private graphQlService: GraphqlService) { }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.getHistoryData(data);
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.getHistoryData(this.session.userInfo);
    }
    
  }

  getHistoryData(data) {
    this.commonDataService.emailId.next(data.user.email);
    this.emailId = data.user.email;
    this.graphQlService.getHomePageComponents().subscribe(homePageLabelData => { 
      var home=homePageLabelData?.filter(x=>x.customMetas?.edges.some(y=>y.node.value=="HomePageLabels"));
      this.getMyHistoryLabel(home[0]); })
    this.httpCallService.getMyHistoryForTable("").subscribe((myHistoryData) => { this.getHistory(myHistoryData); this.outcome = true; this.commonDataService.showLoader.next(false); }, err => {
      let obj = {
        type: 'error',
        displayTime: 10000,
        position: 'bottom',
        message: constObj.microserviceFailureOnMyHistory
      }
      this.commonDataService.notificationObject.next(obj);
      this.outcome = true;
      console.log(err); this.commonDataService.showLoader.next(false);
    });
  }

  private paginator: MatPaginator;
  private sort: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  showHistoryFor: string = "";
  history: string = "";
  last1Day: string = "";
  last7Days: string = "";
  last30Days: string = "";
  last1Year: string = "";
  date: string = "";
  Vieweditem: string = "";
  area: string = "";
  type: string = "";
  VieweditemTitle: string = "";
  getMyHistoryLabel(data) {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.showHistoryFor = labels.filter(x => x.key == "myHistory_showHistoryFor").map(y => y.value);
        this.history = labels.filter(x => x.key == "home_history").map(y => y.value);
        this.last1Day = labels.filter(x => x.key == "myHistory_last1Day").map(y => y.value);
        this.last7Days = labels.filter(x => x.key == "myHistory_last7Days").map(y => y.value);
        this.last30Days = labels.filter(x => x.key == "myHistory_last30Days").map(y => y.value);
        this.last1Year = labels.filter(x => x.key == "myHistory_last1Year").map(y => y.value);
        this.date = labels.filter(x => x.key == "myHistoryTableHeader_date").map(y => y.value);
        this.Vieweditem = labels.filter(x => x.key == "myHistoryTableHeader_Vieweditem").map(y => y.value);
        this.area = labels.filter(x => x.key == "myHistoryTableHeader_Area").map(y => y.value);
        this.type = labels.filter(x => x.key == "myHistoryTableHeader_Type").map(y => y.value); 
        this.VieweditemTitle = labels.filter(x => x.key == "myHistoryTableHeaderTitle_Vieweditem").map(y => y.value);
        this.showhistorylist.push(this.last1Day[0]);
        this.showhistorylist.push(this.last7Days[0]);
        this.showhistorylist.push(this.last30Days[0]);
        this.showhistorylist.push(this.last1Year[0]);
        this.showhistorydefault = new FormControl(this.showhistorylist[0]);
        this.displayedColumns.push(this.date[0])
        this.displayedColumns.push(this.Vieweditem[0])
        this.displayedColumns.push(this.area[0])
        this.displayedColumns.push(this.type[0])
      }
  }

  getHistory(resp) {
    this.actualresult = resp;
    let ress = this.actualresult.map(x => ({ Date: new Date(x.recentDate.split(" ")[0]), Vieweditem: x.historyType == "Annotation" ? x.historyTitle : x.breadCrumb, Area: x.breadCrumb.split("~")[0], Type: (x.historyType == "Annotation" ? "Annotation" : (x.historyTitle.includes("20 Glossary") ? "Glossary" : (x.pageURL.split("/").length <= 3 ? "Section" : (x.pageURL.split("/").length > 3 && x.pageURL.split("/")[3].split("-").length > 3 ? "Paragraph" : "Section")))), Breadcrumb: x.breadCrumb.split("-").pop(), VieweditemURL: x.pageURL, CompleteBreadcrumb: x.breadCrumb, NavigationPath: x.navigationPath }))
      for (let i = 5; i <= 20; i = i + 5) {
        this.pagelistarray.push(i);
      }
    this.dataSource.data = ress as unknown as MyHistory[];
  }

  updateHistory() {
    this.commonDataService.showLoader.next(true);
    this.paginator.pageIndex = 0;
    this.httpCallService.getMyHistoryForTable(this.showhistorydefault.value).subscribe(resp => { this.getHistory(resp); this.commonDataService.showLoader.next(false); }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

  RedirectToVisitedPage(element) {
    event.preventDefault();
    this.route.navigateByUrl(element.VieweditemURL);
  }
  onRightClick(event,element) {
    event.currentTarget.href = element.VieweditemURL;
  }
}
export interface MyHistory {
  Date: Date
  Viewedtem: string;
  Area: string;
  Type: string;
  Breadcrumb: string;
  VieweditemURL: string;
  CompleteBreadcrumb: string;
  NavigationPath: string
}
